import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { info, Sx_Download } from "../../../assets/icons";
import CustomToast, { defaultcustomToatStyle } from "../../../Components/CustomToast/CustomToast";
import Navbar_render from "../../../Pages/ProjectV2/Render/Nav_render/Navbar_render";
import {
  CancellSubscription,
  getCurrentPlan,
  getRendersPlan,
} from "../../../Redux/actions/commonActtion";
import { getRequest } from "../../../services/axios";
import Styles from "./Render.module.css";
import UpgradePlan from "./UpgradePlan";
import UserPlanNav from "../../UserPlan/UserPlanNav";

const formatExpiryDate = (date) => {
  if (!date) return "";

  const options = {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
};

function formatDateTime(isoString) {
  if (!isoString) return "N/A";

  const date = new Date(isoString);

  // Format options
  const options = {
    month: "long",
    day: "numeric",
    year: "numeric",
  };

  const formattedDate = date.toLocaleDateString("en-US", options);

  // Format the time part
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert hours from 24-hour to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // If hours is 0, set it to 12

  // Combine date and time
  return `${formattedDate} ${hours}:${minutes}${ampm}`;
}

function addIntervalToPurchaseDate(
  planPurchaseDate,
  interval_count,
  interval_type
) {
  if (!planPurchaseDate) return null;

  const purchaseDate = new Date(planPurchaseDate); // Create a new date object

  // Check if the purchase date is valid
  if (isNaN(purchaseDate)) {
    return null;
  }

  // Based on the interval_type, add to the date accordingly
  switch (interval_type) {
    case "day":
      purchaseDate.setDate(purchaseDate.getDate() + interval_count);
      break;
    case "month":
      purchaseDate.setMonth(purchaseDate.getMonth() + interval_count);
      break;
    case "year":
      purchaseDate.setFullYear(purchaseDate.getFullYear() + interval_count);
      break;
    default:
      return null;
  }

  return purchaseDate;
}

const MoreInfoPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  // console.log('MoreInfoPage location = ',location);
  const {isDashboard, isCard, projectId, isMoreInfo, isRender} = location?.state;
// console.log('MoreInfoPage to Upgrade projectId=',projectId);

  const pathSegments = location.pathname.split("/");
  // console.log('pathSegments = ',pathSegments);
  const segment = pathSegments[1];
  // console.log('segment = ',segment);

  const project = useSelector((state) => state?.project);
  // console.log('MoreInfoPage Popup Redux Store Data = ',project);

  const [userStripeData, setUserStripeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isUpgradeOpen, setIsUpgradeOpen] = useState(false);
  const [isPlanShow, setIsPlanShow] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  // Get data from Redux store
  const { renderPlan, currentPlan, subscriptionStatus } = useSelector(
    (state) => state.commonReducer
  );
console.log('More Info Page currentPlan => ', currentPlan);

  // Derived values
  const currentPlanDetails = currentPlan?.plan?.plan_detail || null;
  const createdAt = currentPlan?.plan?.createdAt
    ? new Date(currentPlan.plan.createdAt)
    : null;
  const isCancelled = currentPlan?.plan?.subscription_status === 2;

  // Calculate expiration date
  const expirationDate = React.useMemo(() => {
    if (!currentPlanDetails || !createdAt) return null;

    return addIntervalToPurchaseDate(
      createdAt,
      currentPlanDetails.interval_count || 0,
      currentPlanDetails.interval || "month"
    );
  }, [currentPlanDetails, createdAt]);

  // Calculate derived strings
  const currentDate = new Date();
  const isPlanActive = expirationDate ? currentDate < expirationDate : false;

  const expiryString = expirationDate ? `Expire on ${formatExpiryDate(expirationDate)}` : "";

  const interval = currentPlanDetails?.interval_count;
  const renewalString = expirationDate
    ? `Billed ${
        interval === 7 ? "weekly" : interval === 30 ? "monthly" : ""
      } renews ${formatExpiryDate(expirationDate)}`
    : "";

  const currentPlanInterval =
    currentPlanDetails?.price === 99
      ? " / week"
      : currentPlanDetails?.price === 199
      ? " / month"
      : "";

  // Load user data and current plan on component mount
  useEffect(() => {
    dispatch(getCurrentPlan());
    getData();
  }, [dispatch]);

  const getData = async () => {
    setIsLoading(true);
    try {
      const response = await getRequest("/user/getUserStripeDetails");
      if (response.data) {
        setUserStripeData(response.data.invoices || []);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching stripe data:", error);
      setIsLoading(false);
      setError("Network problem");
    }
  };

  const handleCancell = async () => {
    // console.log('handleCancell with order_id = ',currentPlan?.plan?.order_id,);

    if (!currentPlan?.plan?.order_id) {
      toast(
        <CustomToast title="" content={"No active subscription found"} />,
        defaultcustomToatStyle,
      );
      return;
    }

    try {
      const res = await dispatch(CancellSubscription(currentPlan.plan.order_id));

      if (currentPlan?.plan?.subscription_status === 1 && res.data?.success) {
        toast(
          <CustomToast
            title=""
            content={"Subscription cancelled successfully"}
          />,
          defaultcustomToatStyle,
        );
        dispatch(getCurrentPlan());
      }
    } catch (error) {
      console.error("Error cancelling subscription:", error);
      toast(
        <CustomToast title="" content={"Failed to cancel subscription"} />,
        defaultcustomToatStyle,
      );
    }
  };

  const handleMoreInfoUpgrade = () => {
    const isEmptyObject = 
    currentPlan && 
    Object.keys(currentPlan).length === 0 && 
    currentPlan.constructor === Object; 
  
    if (isEmptyObject || currentPlan?.plan?.subscription_status === 2) {
      setIsUpgradeOpen(true);
    } else if (currentPlan?.plan?.subscription_status !== 2) {
      toast(
        <CustomToast
          title="You're already subscribed"
          content={
            "Please cancel your current plan first and then upgrade your plan."
          }
        />,
        defaultcustomToatStyle,
      );
    } else {
      setIsUpgradeOpen(true);
    }
  };

   const navigateHandler = () =>{
    const isEmptyObject = currentPlan && Object.keys(currentPlan).length === 0 && currentPlan.constructor === Object;    
    if (isEmptyObject || currentPlan?.plan?.subscription_status === 2) {

      if(isDashboard ){
        navigate("/user-plans", { state: {isDashboard: true, isMoreInfo: true} });
      }
      
      
      // From Project Navbar Setting => MoreInfo Page and Now  User Plan Upgrafe
      else if (!isDashboard) {
        navigate("/user-plans", { state: {isDashboard: isDashboard, isMoreInfo: true, isCard: isCard, projectId: projectId}});
      }
            
      
      
      //Now Condition From Render Page 
      else if (isRender && isMoreInfo&& isCard){
        navigate("/user-plans", { state: {isRender: isRender, isMoreInfo: true, isCard: true, projectId: projectId}});
      }else if (isRender && isMoreInfo&& !isCard){
        navigate("/user-plans", { state: {isRender: isRender, isMoreInfo: true, isCard: false, projectId: projectId}});
      }     

    }else if (currentPlan?.plan?.subscription_status !== 2) {
      toast(
        <CustomToast title="You're already subscribed" content={"Please cancel your current plan first and then upgrade your plan."} />,
        defaultcustomToatStyle,
      );
    } else {
      setIsUpgradeOpen(true);
    }    
  }

  // Calculate remaining days for UpgradePlan component
  const remainingDays = React.useMemo(() => {
    if (!expirationDate) return 0;

    const timeDiff = expirationDate.getTime() - new Date().getTime();
    return Math.max(0, Math.ceil(timeDiff / (1000 * 3600 * 24)));
  }, [expirationDate]);

  const getRenderPlanDetails = async () => {
    dispatch(getRendersPlan(user));
    dispatch(getCurrentPlan());
  };

  useEffect(() => {
    getRenderPlanDetails();
  }, []);
  const CloseButton = ({ closeToast }) => (
    <i className="material-icons w-7 flex justify-center cursor-pointer not-italic" onClick={closeToast}>✖</i>
  );

  return (
    <div className="w-full h-screen flex flex-col ">
      <ToastContainer closeButton={CloseButton}/>

      <div className="renderHead">
        {/* <Navbar_render closeModal={() => navigate(-1)} title="more_info" /> */}
        <UserPlanNav/>
      </div>

      {/* Plan Info - Give it 1/3rd or auto grow */}
      <div
        className={`${Styles.moreInfoScale} bg-black w-full items-center h-[55%] justify-center flex`}
      >
        <section className="bg-[linear-gradient(135deg,#15171c,#1a1b27,#2d3143)] w-[75%] rounded-[1.5rem] px-[55px] py-[55px]">
          <div className="flex items- justify-between">
            <div className="flex flex-col gap-2">
              <h2 className="text-[28px] text-gray-100 manrope-800 py-2">
                Your ScrollX.io Plan
              </h2>
              <h2 className="text-base text-[#ffffffcc] manrope-400 py-2">
                Manage your billing and plan.
              </h2>
            </div>
            <div>
              <img
                className="w-5 mt-3"
                src={info}
                alt=""
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`/help/670e655049a4f8d9d08f37f5`)}
              />
            </div>
          </div>
          <div className="w-full mt-4 bg-[linear-gradient(90deg,#171717,#000000)] rounded-2xl px-6 py-[45px] text-gray-100 border-[1px] border-[#ffffff33] flex items-center justify-between">
            <div className="flex flex-col gap-2 w-[70%] pl-[3%]">
              <h2 className="text-2xl manrope-800">
                {isPlanActive ? currentPlanDetails?.type : "Basic"} Plan
              </h2>
              <div className="text-base text-white manrope-400">
                <p className="text-base text-white manrope-400 py-1">
                  {isPlanActive
                    ? currentPlanDetails?.text5
                    : "Try ScrollX for free and explore its powerful features."}
                </p>
                <p className="text-base text-white manrope-400 py-1">
                  {isPlanActive
                    ? "Unlimited high resolution scroll and card renders."
                    : "Limited scroll and card renders with watermark"}
                </p>
                {isPlanActive && currentPlanDetails?.price && (
                  <p>
                    US <span>${currentPlanDetails.price}</span>
                    <span>{currentPlanInterval}</span>
                  </p>
                )}
              </div>
            </div>
            <div className=" flex flex-col gap-3 w-[30%]">
              {currentPlan?.plan ? (
                <p className="text-base text-white manrope-400">
                  {isCancelled ? expiryString : renewalString}
                </p>
              ) : (
                <p className="text-base text-white manrope-400">
                  Please upgrade to create end credits !
                </p>
              )}
              <div className="flex gap-4">
                {currentPlan?.plan && (
                  <button
                    onClick={handleCancell}
                    className={`${
                      isCancelled ? "text-white" : "hover:scale-95 text-white"
                    } cursor-pointer flex justify-center items-center bg-[#2a2b36] manrope-600 py-2 px-[24px] rounded-lg transition-all duration-100 ease-in text-base`}
                    disabled={isCancelled}
                  >
                    {isCancelled ? "Cancelled" : "Cancel Subscription"}
                  </button>
                )}
                <button
                  onClick={navigateHandler}
                  className="cursor-pointer flex justify-center items-center bg-[#413caa] text-white manrope-600 py-2 px-[24px] rounded-lg text-base transition-all duration-100 ease-in hover:scale-95"
                >
                  Upgrade
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Invoices Table - Takes remaining space */}
      {!isUpgradeOpen && (
        <div
          className={`${Styles.moreInfoScale} bg-[#171717] flex-1 overflow-hidden h-[35%] `}
        >
          <div className={`${Styles.historytabel} relative pt-5 h-full`}>
            <div className="overflow-hidden h-full flex flex-col ">
              <div
                className={`${Styles.historytabelMoreInfo} sticky top-0 z-10 text-white shadow-md h-[55px] w-full bg-[#333]`}
              >
                <div className="flex items-center justify-center text-xl w-full h-full">
                  {[
                    "Invoice",
                    "Date",
                    "Plan",
                    "Amount",
                    "Download Invoice",
                  ].map((header) => (
                    <div
                      key={header}
                      className="w-[25%] px-4 manrope-600 flex items-center justify-center"
                    >
                      {header}
                    </div>
                  ))}
                </div>
              </div>

              <div className="overflow-y-auto flex-1">
                {isLoading ? (
                  <div className="text-white flex items-center justify-center py-20 text-base">
                    <CgSpinner className="animate-spin text-[2rem]" />
                  </div>
                ) : error ? (
                  <div className="text-red-500 flex items-center justify-center py-8 text-base">
                    Error loading data: {error}
                  </div>
                ) : Array.isArray(userStripeData) &&
                  userStripeData.length > 0 ? (
                  userStripeData.map((invoice, index) => (
                    <div
                      key={index}
                      className="grid grid-cols-5 h-[55px] text-[#ffffff] hover:bg-[#222222] hover:rounded-xl"
                    >
                      <div className="py-[10px] px-4 flex items-center justify-center text-lg manrope-600">
                        {invoice.id || `INV-${index + 1}`}
                      </div>
                      <div className="py-[10px] px-4 flex items-center justify-center text-lg manrope-600">
                        {formatDateTime(invoice.invoiceDate) || "N/A"}
                      </div>
                      <div className="py-[10px] px-4 flex items-center justify-center text-lg manrope-800">
                        {invoice.plan || "Essential"}
                      </div>
                      <div className="py-[10px] px-4 flex items-center justify-center text-lg manrope-600">
                        {invoice.amount || "N/A"}
                      </div>
                      <div className="py-[10px] px-4 flex items-center justify-center text-lg manrope-600">
                        {invoice.invoiceLink ? (
                          <a
                            href={invoice.invoiceLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline text-white text-[1.5rem]"
                          >
                            <img className="w-7" src={Sx_Download} alt="" />
                          </a>
                        ) : (
                          <span>N/A</span>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-white text-center py-8 text-base">
                    {userStripeData && Object.keys(userStripeData).length > 0
                      ? "Invoice data format incorrect"
                      : "No invoice data available"}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* {isUpgradeOpen && (
        <UpgradePlan
          isUpgradeOpen={isUpgradeOpen}
          IsUpgradeOpen={setIsUpgradeOpen}
          currentPlanDetails={currentPlanDetails}
          remainingDays={remainingDays}
          paymentType={currentPlan?.plan?.payment_type}
          order_id={currentPlan?.plan?.order_id}
          subscription_status={currentPlan?.plan?.subscription_status}
        />
      )} */}
    </div>
  );
};

export default MoreInfoPage;
